import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTaxPlannerinline = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 18 18",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.125,
		d: "m6.996 11.003 4.006-4.006m.181 3.866a.225.225 0 1 1-.323 0 .225.225 0 0 1 .323 0M7.14 6.813a.225.225 0 1 1-.323 0 .225.225 0 0 1 .323 0"
	}), /* @__PURE__ */ _jsx("rect", {
		width: 13.506,
		height: 13.506,
		x: 2.247,
		y: 2.247,
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.125,
		rx: 3.75
	})]
});
export default SvgTaxPlannerinline;
